module.exports = __webpack_public_path__ + "7be6a82c302ef54a8b1c18cb19127b85.png";